<app-full-screen-popup [type]="'overlayPopup'" [readonlyForm]="isNonConsentedCP" [buttonText]="'Consent to Publish'"
  [workflowStatus]="workflowStatus"
  [yearCode]="yearCode"
  [workflowUser]="workflowUser"
  [formName]="'consetToPublish'"
  [header]="headerText" (onClose)="onCancel()" (onSubmitNomination)="onSubmitNomination()">
  <app-section [type]="'overlayPopup'">
    <div class="display-body">
      <app-loader [hidden]="!showLoader"></app-loader>
      <app-alert [alert]="alert"></app-alert>
      <div class="public-report">
        <form [formGroup]="consentPublishReportFormGroupControl" *ngIf="consentPublishReportFormGroupControl">
          <div>
            <app-input-textbox [labelName]="'Report name'"
              [inputFormControl]="consentPublishReportFormGroupControl.controls.reportName" [submitted]="submitConsentForm">
            </app-input-textbox>
          </div>
          <div>
            <app-input-textbox [labelName]="'Company releasing the report'"
              [inputFormControl]="consentPublishReportFormGroupControl.controls.releaseReport" [submitted]="submitConsentForm"></app-input-textbox>
          </div>

          <div>
            <app-input-textbox [labelTextTransformNone]="true" [labelName]="'Name of deposit/s for which you are the ' + userTypeText"
              [inputFormControl]="consentPublishReportFormGroupControl.controls.depositeName"></app-input-textbox>
          </div>
          <div>
            <app-input-textbox [labelName]="'Date of report'" [showDatePicker]="true" [placeHolder]="'DD/MM/YYYY'"
              [inputFormControl]="consentPublishReportFormGroupControl.controls.releaseReportDate">
            </app-input-textbox>
          </div>
        </form>
      </div>
      <div class="consent-publish-detail" id="renderHTMLData"></div>

      <form [formGroup]="consentPublishFormGroupControl" *ngIf="consentPublishFormGroupControl">
        <div>
          <app-input-textbox [labelTextTransformNone]="true" [labelName]="'Signature of ' + userTypeText"
            [inputFormControl]="consentPublishFormGroupControl.controls.signedCompetentPerson"></app-input-textbox>

          <app-input-textbox [labelName]="'Date'" [placeHolder]="'DD/MM/YYYY'" [showDatePicker]="true"
            [inputFormControl]="consentPublishFormGroupControl.controls.signedCompetentPersonDate">
          </app-input-textbox>
        </div>

        <div>
          <app-input-textbox [labelName]="'Professional membership'"
            [inputFormControl]="consentPublishFormGroupControl.controls.professionalMembership"></app-input-textbox>

          <app-input-textbox [labelName]="'Membership number'"
            [inputFormControl]="consentPublishFormGroupControl.controls.membershipNumber">
          </app-input-textbox>
        </div>
      </form>
    </div>
  </app-section>
</app-full-screen-popup>

<app-pop-up *ngIf="showSubmitSuccessPopup">
  <app-pop-up-header
    [showSuccessIcon]="true"
    [headerName]="'Success'"
    (close)="goBackToConsentToPublish()"
  ></app-pop-up-header>

  <div class="comment">
    <span class="field-name">{{ successMessage }}</span>
  </div>

  <app-pop-up-footer>
    <app-button
      [name]="'Go to Consent to Publish'"
      [type]="'primary'"
      [textTransformNone]="true"
      (btnClick)="goBackToConsentToPublish()"
    ></app-button>
  </app-pop-up-footer>
</app-pop-up>
